import React from "react";
import LoginLayout from "../../features/auth/layout/LoginLayout";
import { ResetUserPasswordRequestFormPresenter } from "../../features/user/components/ResetPasswordRequestForm/ResetPasswordRequestForm";

export default function ResetPasswordRequestPage() {
  return (
    <>
      <LoginLayout>
        <ResetUserPasswordRequestFormPresenter />
      </LoginLayout>
    </>
  );
}
